import { createFileRoute } from '@tanstack/react-router';
import { AssessmentLayoutComponent } from '@/app/route-components/AssessmentLayoutComponent';

/**
 * 歳出比較査定レイアウトルート
 *
 * 第2メニュー（AssessmentMenu）とページコンテンツを横並びで配置する。
 * LayoutOffsetProvider で additionalLeftOffset を設定し、
 * MainPageLayout の固定ヘッダー位置を第2メニュー幅分ずらす。
 * サイドバーが hidden の場合は第2メニューも非表示になる。
 */
export const Route = createFileRoute('/_protected/assessment')({
  component: AssessmentLayoutComponent,
});
